// extracted by mini-css-extract-plugin
export default {"root":"index__root--h5h4a"};